<template>
  <div>
    <div class="section-actions">
      <el-button size="mini" icon="el-icon-plus" @click="addRow">添加断点</el-button>
    </div>
    <el-table :data="value || []" size="mini" border class="compact-table">
      <el-table-column label="剩余分钟" width="130">
        <template slot-scope="scope">
          <el-input-number :value="scope.row.minutes" :min="0" :step="60" :controls="false" size="mini"
            @change="v => updateRow(scope.$index, 'minutes', v)"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="可读" width="90">
        <template slot-scope="scope">{{ formatMinutes(scope.row.minutes) }}</template>
      </el-table-column>
      <el-table-column label="系数" width="130">
        <template slot-scope="scope">
          <el-input-number :value="scope.row.value" :step="0.05" :precision="2" :controls="false" size="mini"
            @change="v => updateRow(scope.$index, 'value', v)"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="removeRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] }
  },

  methods: {
    formatMinutes(minutes) {
      if (minutes == null || minutes === "") return "-";
      const m = Number(minutes);
      if (Number.isNaN(m)) return "-";
      if (m >= 24 * 60 && m % (24 * 60) === 0) return `${m / (24 * 60)}天`;
      if (m >= 60 && m % 60 === 0) return `${m / 60}小时`;
      return `${m}分钟`;
    },

    emitChange() {
      this.$emit("change");
    },

    addRow() {
      const list = [...(this.value || []), { minutes: 0, value: 0 }];
      this.$emit("input", list);
      this.emitChange();
    },

    removeRow(index) {
      const list = [...(this.value || [])];
      list.splice(index, 1);
      this.$emit("input", list);
      this.emitChange();
    },

    updateRow(index, field, val) {
      const list = (this.value || []).map((row, i) => (i === index ? { ...row, [field]: val } : row));
      this.$emit("input", list);
      this.emitChange();
    }
  }
};
</script>

<style lang="less" scoped>
.section-actions {
  margin-bottom: 8px;
}

.compact-table {
  max-width: 520px;
}
</style>
